import { useTranslation } from 'react-i18next';
import SuccessScreen from '@/components/ui/SuccessScreen/SuccessScreen';

interface SupportedSuccessScreenProps {
  onBackToSupporteds: () => void;
  onAddAnother: () => void;
  /**
   * HAT-1453: the supported was added from inside a new support request, so the natural next step
   * is the request itself. When present the screen asks "continue to the request?" - yes goes on
   * with this supported already chosen, no ends the dialog - instead of the "add another" pair.
   */
  continueToRequest?: {
    supportedName: string;
    onContinue: () => void;
    onFinish: () => void;
  };
  /**
   * HAT-1453: the supporteds-screen success screen keeps its "back / add another" pair and gains
   * these under it - the reporter marked the empty space below the buttons for "move on to a
   * support request", and asked for the way to add further classifications after the basic one.
   */
  listActions?: {
    onGoToRequest?: () => void;
    onAddClassifications?: () => void;
  };
}

const SupportedSuccessScreen = ({
  onBackToSupporteds,
  onAddAnother,
  continueToRequest,
  listActions,
}: SupportedSuccessScreenProps) => {
  const { t } = useTranslation();

  if (continueToRequest) {
    return (
      <SuccessScreen
        title={t('supportedAddedSuccessfully')}
        description={t('supportedClassificationReviewMessage')}
        additionalText={t('continueToSupportRequestQuestion', { name: continueToRequest.supportedName })}
        primaryButtonText={t('continueToSupportRequest')}
        primaryButtonAction={continueToRequest.onContinue}
        secondaryButtonText={t('notNow')}
        secondaryButtonAction={continueToRequest.onFinish}
        showSecondaryIcon={false}
      />
    );
  }

  return (
    <SuccessScreen
      title={t('supportedAddedSuccessfully')}
      description={t('supportedClassificationReviewMessage')}
      primaryButtonText={t('backToSupporteds')}
      primaryButtonAction={onBackToSupporteds}
      secondaryButtonText={t('addAnotherSupported')}
      secondaryButtonAction={onAddAnother}
      extraButtons={[
        ...(listActions?.onGoToRequest ? [{ text: t('goToSupportRequest'), action: listActions.onGoToRequest }] : []),
        ...(listActions?.onAddClassifications ? [{ text: t('addMoreClassifications'), action: listActions.onAddClassifications }] : []),
      ]}
    />
  );
};

export default SupportedSuccessScreen;
